<template>
  <div class="details">
    <div class="retrieveList_title">
      <i class="el-icon-tickets"></i> 常规检索&nbsp; / &nbsp;检索结果&nbsp; /
      &nbsp;<span style="color: #92959b">详情</span>
    </div>
    <el-card class="box-card">
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="著录项目" name="tab1">
            <div class="details_box">
              <div class="xian"></div>
              <div class="xiangqing">
                <ul>
                  <li>申请号</li>
                  <li>申请日</li>
                  <li>申请人所在国家/地区/组织</li>
                  <li>代理人</li>
                  <li>代理机构</li>
                  <li>外观设计洛迦诺分类号</li>
                  <li>公开号（授权）</li>
                  <li>公开日期（授权）</li>
                  <li>申请人（授权）</li>
                  <li>设计人</li>
                  <li>优先权号（授权）</li>
                  <li>发明名称（授权）</li>
                </ul>
                <ul>
                  <li>
                    {{
                      tableList[0].applicationNum == null ||
                      tableList[0].applicationNum == ''
                        ? ' '
                        : tableList[0].applicationNum
                    }}
                  </li>
                  <li>{{ tableList[0].authAnnouncementNo }}</li>
                  <li>{{ tableList[0].country }}</li>
                  <li>{{ tableList[0].agent }}</li>
                  <li>{{ tableList[0].agency }}</li>
                  <li>{{ tableList[0].appearanceDesign }}</li>
                  <li>{{ tableList[0].authAnnouncementNo }}</li>
                  <li>{{ tableList[0].authAnnouncementTime }}</li>
                  <li>{{ tableList[0].applicant }}</li>
                  <li>{{ tableList[0].designer }}</li>
                  <li>{{ tableList[0].priorityNumber }}</li>
                  <li>{{ tableList[0].titleInvention }}</li>
                </ul>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="tab2" label="全文文图">
            <div>被引证</div>
            <el-divider></el-divider>
            <div class="tab2_text">
              <h3>权利要求</h3>
              <div v-html="tableList[0].fullText"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="tab3" label="摘要附图">
            <div>被引证</div>
            <el-divider></el-divider>
            <!-- 富文本方式 -->
            <div v-html="tableList[0].attachedFigures"></div>
            <!-- <Editor /> -->
          </el-tab-pane>
          <el-tab-pane name="tab4" label="说明书附图">
            <div>被引证</div>
            <el-divider></el-divider>
            <!-- 富文本方式 -->
            <div v-html="tableList[0].figure"></div>
            <!-- <Editor /> -->
          </el-tab-pane>
          <el-tab-pane name="tab5" label="全文图像">
            <div>被引证</div>
            <el-divider></el-divider>
            <!-- 富文本方式 -->
            <div v-html="tableList[0].fullTextImage"></div>
            <!-- <Editor /> -->
          </el-tab-pane>
          <el-tab-pane name="tab6" label="法律状态">
            <div>被引证</div>
            <el-divider></el-divider>
            <div class="tab2_text">
              <div>
                {{ tableList[0].lawStatus }}
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="tab7" label="同族">
            <div>被引证</div>
            <el-divider></el-divider>
            <div class="tab2_text">
              <div>
                {{ tableList[0].cognate }}
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="tab8" label="引证">
            <div>被引证</div>
            <el-divider></el-divider>
            <div class="tab2_text">
              <div>
                {{ tableList[0].quote }}
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '../util/request'
export default {
  data() {
    return {
      activeName: 'tab1',
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
        },
      ],
      tableList: [],
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      width: 50, // 默认缩放比例为1，表示原始大小
      minval: 1,
      minval1: 0,
      maxval: 360,
      rotate: 0,
    }
  },
  created() {
    console.log(this.$route.query.id)
    this.getData()
  },

  methods: {
    // 设置表头颜色
    headClass() {
      return {
        background: '#F8F8F9',
        fontWeight: '700',
        color: '#303133',
      }
    },
    handleClick() {},
    getData() {
      request({
        url: `/api/client/common/patent/searchView/${this.$route.query.id}`,
        method: 'get',
      }).then((res) => {
        this.tableList = [{ ...res.data }]
        console.log(this.tableList)
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
    },
    handleZoomChange(value) {
      // 根据滑块的值来设置缩放比例
      this.width = value
    },
    handleZoomChange1(val) {
      this.rotate = val
    },
  },
}
</script>

<style scoped>
.details {
  margin: 10px 120px;
}

.retrieveList_title {
  font-size: 20px;
  font-weight: bold;
  align-items: center;
  display: flex;
  color: #353233;
  margin-bottom: 10px;
}

.xiangqing {
  margin-left: -18px;
  display: flex;
}

.xiangqing ul:nth-child(2) li {
  width: 924px;
  height: 44px;
  background-color: transparent;
}

.xian {
  width: 7px;
  height: 528px;
  background-color: #c6d9f5;
}

ul {
  margin-left: -23px;
}

::v-deep .el-tabs__item.is-active {
  font-weight: bold;
  color: #3763d0;
}

::v-deep .el-tabs__active-bar {
  height: 3px;
  background-color: #3763d0;
}

li {
  list-style: none;
  font-size: 16px;
  background-color: #f0f7ff;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  color: #666666;
  width: 290px;
  padding-left: 15px;
}

.details_box {
  display: flex;
}

.tab2_text {
  overflow: auto;
  max-height: 600px;
}

.tab2_text h3 {
  text-align: center;
  font-weight: 700;
}

.tab2_text div {
  line-height: 38px;
}

::v-deep .el-divider--horizontal {
  margin-top: 12px;
}

::v-deep .el-table--border {
  border-radius: 5px;
}

.pageination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.status {
  margin-left: 10px;
  cursor: pointer;
  color: #3763d0;
}

.divider {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

::v-deep .divider .el-button {
  border: 0 !important;
}

.tab3_slider {
  display: flex;
  align-items: center;
}

.tab3_slider span {
  margin-right: 10px;
}

.tab_img {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: 500px;
  overflow: auto;
  justify-content: center;
}

.tab_img_title {
  color: #000;
  font-size: 18px;
  text-align: center;
}
::v-deep .w-e-text-container {
  height: 500px !important; /*!important是重点，因为原div是行内样式设置的高度300px*/
}
</style>
